import { FC, SVGAttributes } from 'react';

const KakaoRectangle: FC<React.PropsWithChildren<React.PropsWithChildren<SVGAttributes<SVGElement>>>> = ({ ...props }) => {
  return (
    <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <rect width="40" height="40" rx="8" fill="#F7DB3F" />
      <path
        d="M19.9994 8.6665C13.0045 8.6665 7.33337 13.1608 7.33337 18.7055C7.33337 22.3146 9.73539 25.4776 13.3417 27.2469C13.0762 28.2387 12.383 30.8413 12.2436 31.3964C12.0723 32.0873 12.4959 32.078 12.7747 31.8916C12.9925 31.7465 16.2457 29.5287 17.6491 28.5728C18.4277 28.6883 19.2137 28.7461 20.0007 28.7459C26.9956 28.7459 32.6667 24.2502 32.6667 18.7069C32.6667 13.1635 26.9956 8.66783 20.0007 8.66783"
        fill="#3B1B1B"
      />
    </svg>
  );
};

export default KakaoRectangle;
